import { render, staticRenderFns } from "./Workblock.vue?vue&type=template&id=5396b217"
import script from "./Workblock.vue?vue&type=script&lang=js"
export * from "./Workblock.vue?vue&type=script&lang=js"
import style0 from "./Workblock.vue?vue&type=style&index=0&id=5396b217&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports